import { render, staticRenderFns } from "./MailTemplateEdit.vue?vue&type=template&id=6eb97c80&scoped=true&"
import script from "./MailTemplateEdit.vue?vue&type=script&lang=js&"
export * from "./MailTemplateEdit.vue?vue&type=script&lang=js&"
import style0 from "./MailTemplateEdit.vue?vue&type=style&index=0&id=6eb97c80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb97c80",
  null
  
)

export default component.exports